import React from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export  function Benefits() {

    const navigate = useNavigate();

    const { t } = useTranslation();

    const handleClickContact = (e) => {
        e.preventDefault();
        navigate('/contact');
      }

    return (
        <>
            <div className="container-blue reveal">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 reveal">
                            <h2 className="mt-6">{t("index.benefits.title")}</h2>
                        </div>
                    </div>
                    <div className="separar"></div>
                    <div className="row mt-6">
                        <div className="col-md-6 reveal" style={{"transitionDelay":"0ms"}}>
                            <h4>{t("index.benefits.subtitle1")}</h4>
                            <p className="mt-2">{t("index.benefits.description1")}</p>
                        </div>
                        <div className="col-md-6 reveal" style={{"transitionDelay":"80ms"}}>
                            <h4>{t("index.benefits.subtitle5")}</h4>
                            <p className="mt-2">{t("index.benefits.description5")}</p>
                            
                        </div>
                    </div>
                    <div className="separar"></div>
                    <div className="row mt-6">
                        <div className="col-md-6 reveal" style={{"transitionDelay":"160ms"}}>
                            <h4>{t("index.benefits.subtitle2")}</h4>
                            <p className="mt-2">{t("index.benefits.description2")}</p>
                            
                        </div>
                        <div className="col-md-6 reveal" style={{"transitionDelay":"240ms"}}>
                            <h4>{t("index.benefits.subtitle3")}</h4>
                            <p className="mt-2">{t("index.benefits.description3")}</p>
                        </div>
                    </div>
                    <div className="separar"></div>
                    <div className="row mt-6">
                        <div className="col-md-6 reveal" style={{"transitionDelay":"320ms"}}>
                            <h4>{t("index.benefits.subtitle4")}</h4>
                            <p className="mt-2">{t("index.benefits.description4")}</p>
                            
                        </div>
                        <div className="col-md-6 reveal" style={{"transitionDelay":"400ms"}}>
                            <h4>{t("index.benefits.subtitle6")}</h4>
                            <p className="mt-2">{t("index.benefits.description6")}</p>
                            <p>{t("index.benefits.description6_1")}</p>
                        </div>
                    </div>
                    <div className="separar"></div>
                    <div className="row mt-6">
                        <div className="col-md-12 text-center reveal" style={{"transitionDelay":"480ms"}}>
                            <a href="javascript:void();" onClick={(e) => handleClickContact(e)} className="btn btn-primary">{t("index.benefits.button")}</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
        
        )
}

export default Benefits